/**
 * Removes the cookie stored under the given key.
 * @param {string} key The key of the cookie to remove
 *
 * @public
 * @author Alex Kasemir
 */
var removeCookie = function removeCookie(key) {
  document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
/** @component */


export default removeCookie;